var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"no-padding",attrs:{"fluid":""}},[_c('div',{staticClass:"nav-wrapper"},[_c('b-container',[_c('Notifications'),_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12"}},[_c('MainNav')],1)],1)],1)],1),_c('LoadingIndicator'),_c('router-view'),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }